import { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Typography, Table, TableBody, TableRow, TableCell, TableHead
} from '@mui/material';
import moment from 'moment';
import axios from 'axios';
import { MdChevronRight as NextIcon } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { ClickableTableRow, SimecUser } from 'components';
import Moment from 'react-moment';


interface IProps {
    ticketId: string
    dateFrom: moment.Moment
    dateTo: moment.Moment

    onClose: () => void
}

interface ITicketSchedule {
    ticketId: string
    ticketNr: string
    title: string
    customerId?: number
    customerName: string
    teamMembers: ITeamMember[]
    isVisible: boolean
}

interface ITeamMember {
    username: string
    startDate: moment.Moment
    endDate: moment.Moment
}

let ScheduleDetails = (props: IProps) => {
    let history = useHistory();

    let [isLoading, setLoading] = useState(true);
    let [ticketSchedule, setTicketSchedule] = useState<ITicketSchedule>();


    useEffect(() => {
        let getScheduleDetails = async () => {
            try {
                setLoading(true);
                let request = {
                    ticketId: props.ticketId,
                    dateFrom: props.dateFrom,
                    dateTo: props.dateTo
                };

                let res = await axios.get('/api/Schedule/GetScheduleTicketDetails', { params: request });
                setTicketSchedule(res.data.item);
            } catch (error) { }
            finally {
                setLoading(false);
            }
        }

        getScheduleDetails();
    }, []);


    let openDetails = () => {
        if (ticketSchedule?.isVisible !== true) {
            return;
        }
        props.onClose();
        history.push(`/ticket/edit/${ticketSchedule?.ticketNr}`);
    }


    return (
        <Dialog
            open={true}
            maxWidth="md"
            fullWidth={true}
            scroll="paper"
        >
            {ticketSchedule &&
                <>
                    <DialogTitle>
                        Dettagli pianificazione ticket {ticketSchedule.ticketNr} dal <Moment date={props.dateFrom} format="LL" /> al <Moment date={props.dateTo} format="LL" />
                    </DialogTitle>
                    <DialogContent dividers>
                        {isLoading === false &&
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Membro</TableCell>
                                        <TableCell>Da data</TableCell>
                                        <TableCell>A data</TableCell>
                                        <TableCell>Cliente</TableCell>
                                        <TableCell colSpan={2} />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {ticketSchedule.teamMembers
                                        .map((member, index) =>
                                            <ClickableTableRow
                                                key={index}
                                                hover={ticketSchedule?.isVisible === true}
                                                enabled={ticketSchedule?.isVisible === true}
                                                onClick={openDetails}
                                            >
                                                <TableCell>
                                                    <SimecUser username={member.username} />
                                                </TableCell>
                                                <TableCell>
                                                    <Moment date={member.startDate} format="DD/MM/YYYY" />
                                                </TableCell>
                                                <TableCell>
                                                    <Moment date={member.endDate} format="DD/MM/YYYY" />
                                                </TableCell>
                                                <TableCell>{ticketSchedule?.customerName}</TableCell>
                                                <TableCell>{ticketSchedule?.title}</TableCell>
                                                <TableCell align="right">
                                                    {ticketSchedule?.isVisible === true &&
                                                        <Typography variant="h6">
                                                            <NextIcon />
                                                        </Typography>
                                                    }
                                                </TableCell>
                                            </ClickableTableRow>
                                        )}

                                </TableBody>
                            </Table>
                        }
                    </DialogContent>
                </>
            }
            <DialogActions>
                <Button onClick={props.onClose} color="secondary">
                    Chiudi
                </Button>
            </DialogActions>
        </Dialog >
    )
}

export default ScheduleDetails;